
export default function ForWho() {
  const targetAudience = [
    {
      icon: 'ri-focus-3-line',
      text: 'Para quem quer sair do treino bagunçado e começar a treinar com estratégia'
    },
    {
      icon: 'ri-scales-3-line',
      text: 'Para quem busca emagrecer ou hipertrofiar com método'
    },
    {
      icon: 'ri-compass-3-line',
      text: 'Para quem quer constância, direcionamento e acompanhamento'
    },
    {
      icon: 'ri-close-circle-line',
      text: 'Para quem está cansada de treinos genéricos e sem resultado'
    },
    {
      icon: 'ri-time-line',
      text: 'Para mulheres que querem orientação profissional, mas não têm tempo para um personal presencial'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-purple-50 to-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4 font-montserrat">
            Feita Para Mulheres que Querem{' '}
            <span className="text-purple-600">Evoluir</span> — de Verdade
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-inter">
            Se você se identifica com pelo menos um dos pontos abaixo, a Mentoria Team RB é para você
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-1 gap-6 max-w-4xl mx-auto">
          {targetAudience.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-all duration-300 border border-purple-100 hover:border-purple-300"
            >
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-purple-600 text-xl`}></i>
                </div>
                <div className="flex-1">
                  <div className="flex items-center mb-2">
                    <i className="ri-check-line text-green-500 text-xl mr-2"></i>
                    <p className="text-lg font-medium text-gray-800 leading-relaxed font-inter">
                      {item.text}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
